function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon_pencil");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M341.34,90.61,297.89,47.16h0l-43.5-43.5a12.51,12.51,0,0,0-17.68,0L26.28,214.09a12.61,12.61,0,0,0-3.4,6.31L.26,330A12.51,12.51,0,0,0,12.5,345a12.63,12.63,0,0,0,2.53-.26L124.6,322.12a12.61,12.61,0,0,0,6.31-3.4L341.34,108.29A12.52,12.52,0,0,0,341.34,90.61ZM42.68,248.16l54.16,54.17L28.58,316.42Zm79.39,44L52.8,222.93,245.55,30.18,271.35,56,154.71,172.62a12.5,12.5,0,0,0,17.68,17.67L289,73.65l25.79,25.8Z",
  fill: "#fff"
});

var SvgIconPencil = function SvgIconPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 345,
    height: 345,
    viewBox: "0 0 345 345",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_pencil.6b6a0ad6.svg";
export { ForwardRef as ReactComponent };